<template>
  <v-dialog v-model="data.open" max-width="900px" persistent scrollable>
    <v-card class="inspection-finish">
      <v-card-title class="inspection-finish__header">
        <div class="flex-grow-1">
          <div class="inspection-finish__title">{{ $t(data.title) }}</div>
          <div v-if="subtitle" class="inspection-finish__subtitle">{{ subtitle }}</div>
        </div>
        <v-btn icon @click="closeform">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="inspection-finish__body">
        <formComponent
          ref="formComponent"
          :form="inspectionForm"
          v-model="item"
        />
      </v-card-text>
      <v-divider />
      <v-card-actions class="inspection-finish__footer">
        <v-btn color="primary" outlined @click="closeform">
          {{ $t("general.back") }}
        </v-btn>
        <div class="flex-grow-1"></div>
        <v-btn
          v-if="!isReadOnlyUser"
          color="primary"
          depressed
          data-cy="saveEvent"
          @click="saveForm()"
        >
          <v-icon left>mdi-check</v-icon>
          {{ $t("inspections.closeInspection") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
function getDefaultData() {
  return {
    name: "",
    filetype: "",
    content: "",
    nextExecution: new Date(
      new Date().setFullYear(new Date().getFullYear() + 1)
    ),
  };
}
import formComponent from "../../_utils/formComponent/formComponent.vue";
import { getUniqueId } from "../../api/api";
export default {
  components: { formComponent },
  props: ["data", "item"],
  data: () => ({
    inspectionForm: {
      formData: getDefaultData(),
      form: [
        [
          {
            cols: 12,
            sm: 12,
            md: 12,
            class: "py-0 mt-0",
            id: getUniqueId(),
            componentName: "inspectionFinishForm",
            config: {},
          },
        ],
      ],
    },
  }),
  computed: {
    subtitle() {
      const parts = [];
      const folder = this.$route.params.inspectionCategoryName;
      if (folder) parts.push(folder);
      if (this.item && this.item.title) parts.push(this.item.title);
      if (this.item && this.item.inspectionDate) {
        parts.push(
          new Date(this.item.inspectionDate).toLocaleDateString("de-DE", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })
        );
      }
      return parts.join(" · ");
    },
  },
  methods: {
    closeform() {
      this.data.open = false;
      this.resetData();
    },
    async saveForm() {
      const updatedInspection = await this.$store.dispatch("updateInspection", {
        ...this.item,
        status: "Closed",
      });
      this.$store.commit(
        "CREATE_SNACKBAR",
        this.$t("snackbars.inspectionChanged", { name: updatedInspection.title })
      );
      this.closeform();
    },
    resetData() {
      this.data.open = false;
      //reset form component form only after contact create
      this.$refs.formComponent.resetForm();
      //trigger reload data function in parent component
      this.reloadData();
    },
    reloadData() {
      this.$emit("reloadData");
    },
  },
};
</script>

<style scoped>
.inspection-finish__header {
  align-items: flex-start;
  padding: 20px 24px 16px;
}
.inspection-finish__title {
  font-size: 1.35rem;
  font-weight: 500;
  line-height: 1.3;
}
.inspection-finish__subtitle {
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 2px;
  font-weight: 400;
}
.inspection-finish__body {
  padding: 8px 24px 16px !important;
  background: #fafafa;
}
.inspection-finish__footer {
  padding: 12px 24px;
}
</style>
